"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ListItem = _interopRequireDefault(require("../../../ListItem"));
var _ListItemText = _interopRequireDefault(require("../../../ListItemText"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)({
  listItem: {
    cursor: "pointer",
    paddingTop: 4,
    paddingBottom: 4
  }
});
var PresetListItem = function PresetListItem(_ref) {
  var value = _ref.value,
    label = _ref.label,
    onSelect = _ref.onSelect,
    selected = _ref.selected,
    id = _ref.id;
  var classes = useStyles();
  var handlePresetSelect = function handlePresetSelect() {
    return onSelect(value, id);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem["default"], {
    selected: selected,
    onClick: handlePresetSelect,
    className: classes.listItem,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
      primary: label
    })
  });
};
var _default = exports["default"] = PresetListItem;